import { Component } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import QuemSomos from './pages/QuemSomos';
import Engenheiro from './pages/Engenheiro';
import Servicos from './pages/Servicos';
import PmpEmpresas from './pages/PmpEmpresas';
import Portfolio from './pages/Portfolio';
import Diferenciais from './pages/Diferenciais';
import Simulador from './pages/Simulador';
import Depoimentos from './pages/Depoimentos';
import Contato from './pages/Contato';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="grid min-h-screen place-items-center p-8 text-center">
          <div>
            <h1 className="font-display text-2xl font-bold text-navy dark:text-white">Algo saiu do prumo.</h1>
            <p className="mt-2 text-muted-c">Recarregue a página para continuar.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/quem-somos" element={<QuemSomos />} />
              <Route path="/responsavel-tecnico" element={<Engenheiro />} />
              <Route path="/servicos" element={<Servicos />} />
              <Route path="/pmp-empresas" element={<PmpEmpresas />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/diferenciais" element={<Diferenciais />} />
              <Route path="/simulador" element={<Simulador />} />
              <Route path="/depoimentos" element={<Depoimentos />} />
              <Route path="/contato" element={<Contato />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
